import { observable } from 'mobx'

export class HeroStore {
  @observable
  scrollTarget: number = 0

  @observable
  bgFadeIn: boolean = false
}
